(function () {
  'use strict';
  const SELECTOR = '.bumzee-price-facet';
  function initPriceSlider(component) {
    if (!component) return;
    if (component.dataset.bumzeeReady === 'true') {
      return;
    }
    const minSlider = component.querySelector('.bumzee-range--min');
    const maxSlider = component.querySelector('.bumzee-range--max');
    const hiddenMin = component.querySelector('.bumzee-price-min-hidden');
    const hiddenMax = component.querySelector('.bumzee-price-max-hidden');
    const range = component.querySelector('.bumzee-slider-range');
    const minLabel = component.querySelector('.bumzee-price-display__min');
    const maxLabel = component.querySelector('.bumzee-price-display__max');

    if (!minSlider || !maxSlider || !hiddenMin || !hiddenMax || !range) {
      return;
    }

    component.dataset.bumzeeReady = 'true';
    const sliderMax = Number(component.dataset.sliderMax) || 2000;
    const currency = component.dataset.currency || '₹';
    function formatPrice(value) {
      return (currency + Math.round(value).toLocaleString('en-IN'));
    }


    function updateUI() {
      let min = Number(minSlider.value);
      let max = Number(maxSlider.value);
      min = Math.max(0, Math.min(min, sliderMax));
      max = Math.max(0, Math.min(max, sliderMax));
      if (min >= max) {
        if (document.activeElement === minSlider) {
          min = Math.max(0, max - 1);
          minSlider.value = min;
        } else {
          max = Math.min(sliderMax, min + 1);
          maxSlider.value = max;
        }
      }

      const left = (min / sliderMax) * 100;
      const right = 100 - ((max / sliderMax) * 100);
      range.style.left = `${left}%`;
      range.style.right = `${right}%`;
      if (minLabel) {
        minLabel.textContent = formatPrice(min);
      }
      if (maxLabel) {
        maxLabel.textContent = formatPrice(max);
      }
    }

    function updateShopifyInputs() {
      const min = Number(minSlider.value);
      const max = Number(maxSlider.value);
      if (min <= 0) {
        hiddenMin.value = '';
      } else {
        hiddenMin.value = Math.round(min);
      }

      if (max >= sliderMax) {
        hiddenMax.value = '';
      } else {
        hiddenMax.value = Math.round(max);
      }
    }

    function applyFilter() {
      updateShopifyInputs();
      const facets = component.closest('facets-form-component');
      if (!facets) {
        console.error('[BUMZEE] facets-form-component not found');
        return;
      }
      if (typeof facets.updateFilters === 'function') {
        facets.updateFilters();
      } else {
        console.error('[BUMZEE] Horizon updateFilters() unavailable');
      }
    }

    minSlider.addEventListener('input', function () {
      let min = Number(minSlider.value);
      const max = Number(maxSlider.value);
      if (min >= max) {
        min = Math.max(0, max - 1);
        minSlider.value = min;
      }
      updateUI();
    });

    maxSlider.addEventListener('input', function () {
      let max = Number(maxSlider.value);
      const min = Number(minSlider.value);
      if (max <= min) {
        max = Math.min(sliderMax, min + 1);
        maxSlider.value = max;
      }
      updateUI();
    });

    minSlider.addEventListener('change', applyFilter);
    maxSlider.addEventListener('change', applyFilter);

    function keyboardChange(event) {
      const allowed = [ 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (!allowed.includes(event.key)) {
        return;
      }
      updateUI();
      applyFilter();
    }
    minSlider.addEventListener('keyup', keyboardChange);
    maxSlider.addEventListener('keyup', keyboardChange);
    updateUI();
    updateShopifyInputs();
  }
  
  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initPriceSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  const observer = new MutationObserver(function (mutations) {
    let found = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) {
          return;
        }
        if (node.matches && node.matches(SELECTOR)) {
          found = true;
        }
        if (node.querySelector && node.querySelector(SELECTOR)) {
          found = true;
        }
      });
    });

    if (found) {
      requestAnimationFrame(initAll);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();